import React from 'react';
import TaskButton from './TaskButton';
import { Link } from 'react-router-dom';

class ActionButton extends React.Component {
    render() {
        return (
            <span>
                <TaskButton label='Approve' taskId={this.props.taskId} type='approve' />
                <TaskButton label='Reject' taskId={this.props.taskId} type='reject' />
            </span>
        )
    }
}

const UserTaskList = props => {
    if (!props.tasks) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.tasks.length === 0) {
        return (
            <div className='empty'>
                No tasks...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>key</th>
                        <th>created</th>
                        <th>task</th>
                        {/* <th>user</th> */}
                        <th>amount</th>
                        <th>details</th>
                        <th>action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.tasks.map(task => {
                            if (task.task === 'Account.Withdraw') {
                                return (
                                    <tr key={task.key}>
                                        <td>{task.key}</td>
                                        <td>{task.created}</td>
                                        <td>{task.action}</td>
                                        {/* <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td> */}
                                        <td>{task.variable.amount}</td>
                                        <td className="keyfield">
                                            <strong>SWIFT:</strong> {task.variable.account.swiftCode} <br />
                                            <strong>Account Name:</strong> {task.variable.account.accountName} <br />
                                            <strong>Account Number:</strong> {task.variable.account.accountNumber} <br />
                                            <strong>Bank Address:</strong> {task.variable.account.bankAddress} <br />
                                            <strong>Bank Name:</strong> {task.variable.account.bankName} <br />
                                            <strong>Country Code:</strong> {task.variable.account.countryCode} <br />
                                            <strong>Currency Code:</strong> {task.variable.account.currencyCode} <br />
                                        </td>
                                        <td><ActionButton task={task.task} action={task.action} taskId={task.key} /></td>
                                    </tr>
                                )
                            }
                            else if (task.task === 'User.KYC') {
                                return (
                                    <tr key={task.key}>
                                        <td>{task.key}</td>
                                        <td>{task.created}</td>
                                        <td>{task.action}</td>
                                        {/* <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td> */}
                                        <td>{''}</td>
                                        <td className="keyfield">
                                            <strong>Type:</strong> {task.variable.type} <br />
                                            <strong>Name:</strong> {task.variable.name} <br />
                                            <strong>Number:</strong> {task.variable.number} <br />
                                            <strong>Expiry:</strong> {task.variable.expiry} <br />
                                            <strong>Address:</strong> {task.variable.address} <br />
                                            <strong>Photo:</strong> <a target='_blank' href={task.variable.idLink}>Photo Link</a>
                                        </td>
                                        <td>
                                            <ActionButton task={task.task} action={task.action} taskId={task.key} />
                                        </td>
                                    </tr>
                                )
                            }
                            else if (task.task === 'User.Bank') {
                                return (
                                    <tr key={task.key}>
                                        <td>{task.key}</td>
                                        <td>{task.created}</td>
                                        <td>{task.action}</td>
                                        {/* <td><Link to={`/users/${task.variable.user}`}>User Detail</Link></td> */}
                                        <td>{''}</td>
                                        <td className="keyfield">
                                            <strong>Amount1:</strong> {task.variable.amount1} <br />
                                            <strong>Amount2:</strong> {task.variable.amount2} <br />
                                            <strong>Verify Code:</strong> {task.variable.verifyCode} <br />
                                            <strong>SWIFT:</strong> {task.variable.swiftCode} <br />
                                            <strong>Account Name:</strong> {task.variable.accountName} <br />
                                            <strong>Account Number:</strong> {task.variable.accountNumber} <br />
                                            <strong>Bank Address:</strong> {task.variable.bankAddress} <br />
                                            <strong>Bank Name:</strong> {task.variable.bankName} <br />
                                            <strong>Country Code:</strong> {task.variable.countryCode} <br />
                                            <strong>Currency Code:</strong> {task.variable.currencyCode} <br />
                                        </td>
                                        <td><ActionButton task={task.task} action={task.action} taskId={task.key} /></td>
                                    </tr>
                                )
                            }
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default UserTaskList;



// WEBPACK FOOTER //
// ./src/components/widgets/UserTaskList.js